import { RootState } from '../interfaces/redux.interface';

export const getCompany = (state: RootState): RootState['company'] => state.company;
